// extracted by mini-css-extract-plugin
export default {"root":"Container_root__wNH73","container":"Container_container__MM274"};